export class AddCommentModel {
  tblCommentId: number = 0;
  commenterId: string = "";
  comment : string = "";
  PKTableId: string = "";
  formId:string ="";
  isActive: boolean = true;
  isDelete: boolean = false;
  isDeactivate: boolean = false;
  createdOnUTC: Date = new Date();
  createdBy: string = "";
  updatedOnUTC: Date = new Date();
  updatedBy: string = "";
}

export class AddCommentConfigurationModel{
  isEditable = true;
  isDeletable = true;
  showAvtar = true;
  showAddAttachment = true;
  formId:string = '';
}

export class CommentViewModel {
  tblCommentId: number = 0;
  commenterId: string = "";
  comment: string = "";
  PKTableId: string = "";
  formId: string = "";
  tblDocumentIds: string = ""; //comma separated document list those attachced to respective comments.
  isActive: boolean = true;
  isDelete: boolean = false;
  isDeactivate: boolean = false;
  createdOnUTC: Date = new Date();
  createdBy: string = ""; 
}
